import React from 'react'
import Tippy from '@tippyjs/react/headless'

const Dropdown = props => (
  <Tippy placement="bottom-start" interactive={true} {...props} />
)

export default Dropdown
